import i18n from "@/i18n";
import { CREDIT_PRODUCT_TYPE, ROUTE_PATH, MOBILE_ROUTE_PATH } from "@/utils/Global";
import { isMobileApp } from "@/utils/MobileAppUserAgentChecker";

const _GetAiToolDataMap = () => {
    const isMobile = isMobileApp();
    return {
        [CREDIT_PRODUCT_TYPE.REMOVE_BG]: {
            title: i18n.t("common.ai.tab.remove.background"),
            description: i18n.t("common.ai.tab.remove.background.des"),
            id: CREDIT_PRODUCT_TYPE.REMOVE_BG,
            img: "rm-bg.jpg",
            hover: "rm-bg.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_REMOVE_BACKGROUND : ROUTE_PATH.AI_TOOLS_REMOVE_BACKGROUND,
            duration: 4000,
        },
        [CREDIT_PRODUCT_TYPE.UPSCALING]: {
            title: i18n.t("common.ai.tab.upscale"),
            description: i18n.t("common.ai.tab.upscale.des"),
            id: CREDIT_PRODUCT_TYPE.UPSCALING,
            img: "upscale.jpg",
            hover: "upscale.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_UPSCALING : ROUTE_PATH.AI_TOOLS_UPSCALING,
            duration: 4000,
        },
        [CREDIT_PRODUCT_TYPE.ERASE_OBJ]: {
            title: i18n.t("common.ai.tab.erase.object"),
            description: i18n.t("common.ai.tab.erase.object.des"),
            id: CREDIT_PRODUCT_TYPE.ERASE_OBJ,
            img: "erase.jpg",
            hover: "erase.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_ERASE_OBJECT : ROUTE_PATH.AI_TOOLS_ERASE_OBJECT,
            duration: 4500,
        },
        [CREDIT_PRODUCT_TYPE.INPAINT]: {
            title: i18n.t("common.ai.tab.inpaint"),
            description: i18n.t("common.ai.tab.inpaint.des"),
            id: CREDIT_PRODUCT_TYPE.INPAINT,
            img: "inpaint.jpg",
            hover: "inpaint.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_INPAINT : ROUTE_PATH.AI_TOOLS_INPAINT,
            duration: 5500,
        },
        [CREDIT_PRODUCT_TYPE.GENERATE_BG_RELIGHT]: {
            title: i18n.t("common.ai.tab.change.background"),
            description: i18n.t("common.ai.tab.change.background.des"),
            id: CREDIT_PRODUCT_TYPE.GENERATE_BG_RELIGHT,
            img: "gen-bg.jpg",
            hover: "gen-bg.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_GENERATE_BACKGROUND_RELIGHT : ROUTE_PATH.AI_TOOLS_GENERATE_BACKGROUND_RELIGHT,
            duration: 4500,
        },
        [CREDIT_PRODUCT_TYPE.EXTEND_IMG]: {
            title: i18n.t("common.ai.tab.extend.img"),
            description: i18n.t("common.ai.tab.extend.img.des"),
            id: CREDIT_PRODUCT_TYPE.EXTEND_IMG,
            img: "extend.jpg",
            hover: "extend.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_EXTEND_IMAGE : ROUTE_PATH.AI_TOOLS_EXTEND_IMAGE,
            duration: 4000,
        },
        [CREDIT_PRODUCT_TYPE.GENERATE_COPY]: {
            title: i18n.t("common.ai.tab.generate.copy"),
            description: i18n.t("common.ai.tab.generate.copy.des"),
            id: CREDIT_PRODUCT_TYPE.GENERATE_COPY,
            img: "copy.jpg",
            hover: "copy.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_GENERATE_COPY : ROUTE_PATH.AI_TOOLS_GENERATE_COPY,
            duration: 6000,
        },
        // TO-DO :: 스케치 투 이미지 임시 로직
        [CREDIT_PRODUCT_TYPE.SKETCH_TO_IMAGE]: {
            title: i18n.t("common.ai.studio.tab.sketch.to.image"),
            description: i18n.t("common.ai.studio.tab.sketch.to.image.des"),
            id: CREDIT_PRODUCT_TYPE.SKETCH_TO_IMAGE,
            img: "sketch-to-image.jpg",
            hover: "sketch-to-image.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_SKETCH_TO_IMAGE : ROUTE_PATH.AI_TOOLS_SKETCH_TO_IMAGE,
            duration: 4500,
        },
    }
}

const _GetAIStudioDataMap = () => {
    const isMobile = isMobileApp();
    return {
        [CREDIT_PRODUCT_TYPE.SKETCH_TO_IMAGE]: {
            title: i18n.t("common.ai.studio.tab.sketch.to.image"),
            description: i18n.t("common.ai.studio.tab.sketch.to.image.des"),
            id: CREDIT_PRODUCT_TYPE.SKETCH_TO_IMAGE,
            img: "sketch-to-image.jpg",
            hover: "sketch-to-image.webp",
            // TO-DO :: 스케치 투 이미지 임시 로직
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_SKETCH_TO_IMAGE : ROUTE_PATH.AI_TOOLS_SKETCH_TO_IMAGE,
            // routePath: ROUTE_PATH.SKETCH_TO_IMAGE,
            duration: 5000,
        },
        [CREDIT_PRODUCT_TYPE.IMAGE_TO_VIDEO]: {
            title: i18n.t("common.ai.studio.tab.image.to.video"),
            description: i18n.t("common.ai.studio.tab.image.to.video.des"),
            id: CREDIT_PRODUCT_TYPE.IMAGE_TO_VIDEO,
            img: "image-to-video.jpg",
            hover: "image-to-video.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.AI_TOOLS_IMAGE_TO_VIDEO : ROUTE_PATH.IMAGE_TO_VIDEO,
            duration: 5500,
        },
    }
}

const _GetURLToVideoDataMap = () => {
    const isMobile = isMobileApp();
    return {
        [CREDIT_PRODUCT_TYPE.YOUTUBE_URL_TO_VIDEO]: {
            title: i18n.t("common.shorts.tab.youtube.url.to.shorts"),
            description: i18n.t("common.shorts.tab.youtube.url.to.shorts.des"),
            id: CREDIT_PRODUCT_TYPE.YOUTUBE_URL_TO_VIDEO,
            img: "youtube-url-to-shorts.jpg",
            hover: "youtube-url-to-shorts.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.YOUTUBE_SHORTS : ROUTE_PATH.YOUTUBE_SHORTS,
            duration: 5000,
        },
        [CREDIT_PRODUCT_TYPE.PRODUCT_URL_TO_VIDEO]: {
            title: i18n.t("common.shorts.tab.product.url.to.shorts"),
            description: i18n.t("common.shorts.tab.product.url.to.shorts.des"),
            notice: i18n.t("common.shorts.tab.product.url.to.shorts.notice"),
            id: CREDIT_PRODUCT_TYPE.PRODUCT_URL_TO_VIDEO,
            img: "product-url-to-shorts.jpg",
            hover: "product-url-to-shorts.webp",
            routePath: isMobile ? MOBILE_ROUTE_PATH.YOUTUBE_SHORTS : ROUTE_PATH.YOUTUBE_SHORTS,
            duration: 5500,
        },
    }
}

const GetAllAiToolDatas = () => {
    return Object.values(_GetAiToolDataMap())
}

/**
 * 
 * @param {string} productId 
 * @returns {Object | undefined}
 */
const GetAiToolData = (productId) => {
    return _GetAiToolDataMap()[productId]
}

const GetAllAIStudioDatas = () => {
    return Object.values(_GetAIStudioDataMap())
}

/**
 * 
 * @param {string} productId 
 * @returns {Object | undefined}
 */
const GetAIStudioData = (productId) => {
    return _GetAIStudioDataMap()[productId]
}

const GetAllURLToVideoDatas = () => {
    return Object.values(_GetURLToVideoDataMap())
}

/**
 * 
 * @param {string} productId 
 * @returns {Object | undefined}
 */
const GetURLToVideoData = (productId) => {
    return _GetURLToVideoDataMap()[productId]
}

export default {
    GetAllAiToolDatas,
    GetAiToolData,
    GetAllAIStudioDatas,
    GetAIStudioData,
    GetAllURLToVideoDatas,
    GetURLToVideoData,
}